import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { InsuranceCompanyCreateComponent } from './insurance-company-create/insurance-company-create.component';
import { InsuranceCompanyDetailsComponent } from './insurance-company-details/insurance-company-details.component';
import { InsuranceCompanyEditComponent } from './insurance-company-edit/insurance-company-edit.component';

const routes: Routes = [
  {
    path: 'Insurance/InsuranceCompanies',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceCompany,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: InsuranceCompanyDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceCompany,
          breadcrumb: { label: ' ', alias: 'insuranceCompanyDetails' },
        },
      },
      {
        path: 'Edit/:id',
        component: InsuranceCompanyEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceCompany,
          breadcrumb: { label: ' ', alias: 'insuranceCompanyEdit' },
        },
      },
      {
        path: 'Create',
        component: InsuranceCompanyCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Insurance,
          moduleId: ModuleId.insurance,
          entity: Entity.InsuranceCompany,
          breadcrumb: { label: ' ', alias: 'insuranceCompanyCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InsuranceCompanyRoutingModule {}
